import { SINGLE_PURCHASE } from "../../types/types/purchase-types.js";
const getDisplayPrice = (activeVariant, state) => {
  let price = activeVariant.purchaseTypePrices[state.selectedPurchaseType];
  if (!price) {
    console.error(
      `No price found for purchase type "${state.selectedPurchaseType}" on variant with sku: ${activeVariant.sku}`
    );
    price = activeVariant.purchaseTypePrices[SINGLE_PURCHASE];
  }
  return price;
};
export {
  getDisplayPrice
};
//# sourceMappingURL=get-display-price.js.map
